import { render } from "./CreateProfileView.vue?vue&type=template&id=282cc8c7&scoped=true"
import script from "./CreateProfileView.vue?vue&type=script&lang=js"
export * from "./CreateProfileView.vue?vue&type=script&lang=js"

import "./CreateProfileView.vue?vue&type=style&index=0&id=282cc8c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282cc8c7"]])

export default __exports__